var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.isScroll }, [
    _c(
      "div",
      { staticStyle: { width: "95%" } },
      [
        _vm.showVForm
          ? [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Tipo" }
                            },
                            [
                              _c("multiselect", {
                                attrs: {
                                  placeholder: "Tipo",
                                  "deselect-label":
                                    "Click o enter para deseleccionar",
                                  "select-label":
                                    "Click o enter para seleccionar",
                                  "tag-placeholder": "Añadir nuevo tipo",
                                  taggable: true,
                                  options: _vm.aparatos_tipos_options,
                                  multiple: false,
                                  "close-on-select": true,
                                  "preselect-first": false
                                },
                                on: { tag: _vm.addTag },
                                model: {
                                  value: _vm.newVehiculo.aparato_or_vehiculo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newVehiculo,
                                      "aparato_or_vehiculo",
                                      $$v
                                    )
                                  },
                                  expression: "newVehiculo.aparato_or_vehiculo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Potencia o consumo" }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric",
                                    expression: "'numeric'"
                                  }
                                ],
                                attrs: {
                                  "data-vv-scope": "gestion",
                                  name: "Potencia o consumo",
                                  disabled: !_vm.hasPermision("E")
                                },
                                model: {
                                  value: _vm.newVehiculo.potencia_or_consumo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newVehiculo,
                                      "potencia_or_consumo",
                                      $$v
                                    )
                                  },
                                  expression: "newVehiculo.potencia_or_consumo"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(
                                      "gestion.Potencia o consumo"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _vm.hasPermision("E")
                    ? _c(
                        "b-col",
                        { staticStyle: { "text-align": "right" } },
                        [
                          _c(
                            "b-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.showVForm = false
                                }
                              }
                            },
                            [_vm._v("Cancelar")]
                          ),
                          _vm._v(" "),
                          _c("b-button", { on: { click: _vm.saveVForm } }, [
                            _vm._v("Guardar")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          : _vm.showCForm
          ? [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Combustible" }
                            },
                            [
                              _c("multiselect", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  "data-vv-scope": "gestion",
                                  name: "Combustible",
                                  placeholder: "Combustible",
                                  "deselect-label":
                                    "Click o enter para deseleccionar",
                                  "select-label":
                                    "Click o enter para seleccionar",
                                  "tag-placeholder": "Añadir nuevo combustible",
                                  taggable: true,
                                  options: _vm.combustibles_tipos_options,
                                  multiple: false,
                                  "close-on-select": true,
                                  "preselect-first": false
                                },
                                on: { tag: _vm.addTag_comb_tipo },
                                model: {
                                  value: _vm.newCombustible.combustible,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newCombustible,
                                      "combustible",
                                      $$v
                                    )
                                  },
                                  expression: "newCombustible.combustible"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first("gestion.Combustible")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Uso" }
                            },
                            [
                              _c("multiselect", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  "data-vv-scope": "gestion",
                                  name: "Uso",
                                  placeholder: "Uso",
                                  "deselect-label":
                                    "Click o enter para deseleccionar",
                                  "select-label":
                                    "Click o enter para seleccionar",
                                  "tag-placeholder": "Añadir nuevo uso",
                                  taggable: true,
                                  options: _vm.combustibles_usos_options,
                                  multiple: false,
                                  "close-on-select": true,
                                  "preselect-first": false
                                },
                                on: { tag: _vm.addTag_comb_uso },
                                model: {
                                  value: _vm.newCombustible.uso,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newCombustible, "uso", $$v)
                                  },
                                  expression: "newCombustible.uso"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(_vm._s(_vm.errors.first("gestion.Uso")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Consumo anual (kWh/Año)" }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric",
                                    expression: "'numeric'"
                                  }
                                ],
                                attrs: {
                                  "data-vv-scope": "gestion",
                                  name: "Consumo anual (kWh/Año)",
                                  disabled: !_vm.hasPermision("E")
                                },
                                model: {
                                  value: _vm.newCombustible.consumo_anual,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newCombustible,
                                      "consumo_anual",
                                      $$v
                                    )
                                  },
                                  expression: "newCombustible.consumo_anual"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(
                                      "gestion.Consumo anual (kWh/Año)"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _vm.hasPermision("E")
                    ? _c(
                        "b-col",
                        { staticStyle: { "text-align": "right" } },
                        [
                          _c(
                            "b-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.showCForm = false
                                }
                              }
                            },
                            [_vm._v("Cancelar")]
                          ),
                          _vm._v(" "),
                          _c("b-button", { on: { click: _vm.saveCForm } }, [
                            _vm._v("Guardar")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          : _vm.showPptoForm || _vm.showPptoTable || _vm.editPptoFlag
          ? [
              _vm.showPptoForm
                ? [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Dirección estructurada" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.detalles.direccion_estructurada,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.detalles,
                                            "direccion_estructurada",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detalles.direccion_estructurada"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: {
                                      label: "Dirección no estructurada"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.detalles
                                            .direccion_no_estructurada,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.detalles,
                                            "direccion_no_estructurada",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detalles.direccion_no_estructurada"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Código postal" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.detalles.codigo_postal,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.detalles,
                                            "codigo_postal",
                                            $$v
                                          )
                                        },
                                        expression: "detalles.codigo_postal"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Provincia" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.detalles.provincia,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.detalles,
                                            "provincia",
                                            $$v
                                          )
                                        },
                                        expression: "detalles.provincia"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Municipio" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.detalles.municipio,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.detalles,
                                            "municipio",
                                            $$v
                                          )
                                        },
                                        expression: "detalles.municipio"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Población" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.detalles.poblacion,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.detalles,
                                            "poblacion",
                                            $$v
                                          )
                                        },
                                        expression: "detalles.poblacion"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.text,
                                      expression: "text"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.text },
                                  on: {
                                    keyup: function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search($event)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.text = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    !_vm.loading
                                      ? _c(
                                          "b-btn",
                                          {
                                            attrs: { variant: "info" },
                                            on: { click: _vm.search }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Buscar\n                    "
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-search"
                                            })
                                          ]
                                        )
                                      : _c(
                                          "b-btn",
                                          {
                                            attrs: {
                                              variant: "info",
                                              disabled: ""
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-spinner fa-pulse",
                                              staticStyle: {
                                                "padding-left": "0em"
                                              }
                                            })
                                          ]
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    !_vm.loading
                                      ? _c(
                                          "b-btn",
                                          {
                                            attrs: { variant: "danger" },
                                            on: { click: _vm.clearSearch }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Limpiar\n                    "
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-times"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasPermision("E")
                          ? _c(
                              "b-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { cols: "4" }
                              },
                              [
                                _c(
                                  "b-button",
                                  { on: { click: _vm.cancelPptoList } },
                                  [_vm._v("Cancelar")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  { on: { click: _vm.savePptoForm } },
                                  [_vm._v("Guardar")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm._l(_vm.entidades, function(entidad, $index) {
                      return _c(
                        "div",
                        { key: $index },
                        [
                          _c("EntidadSlot", {
                            attrs: { entidad: entidad },
                            on: { select: _vm.select, deselect: _vm.deselect }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "infinite-loading",
                      {
                        attrs: { identifier: _vm.infiniteId },
                        on: { infinite: _vm.infiniteHandler }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "no-more" }, slot: "no-more" },
                          [_vm._v("No hay más entidades")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "no-results" }, slot: "no-results" },
                          [_vm._v("No se han encontrado entidades")]
                        )
                      ]
                    )
                  ]
                : _vm.editPptoFlag
                ? [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Entidad" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.editPpto.id_entidad
                                            .nombre_entidad,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editPpto.id_entidad,
                                            "nombre_entidad",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "editPpto.id_entidad.nombre_entidad"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Status" }
                                  },
                                  [
                                    _c("b-form-select", {
                                      staticClass: "mb-3",
                                      attrs: {
                                        options: _vm.ppto_status_options
                                      },
                                      on: { input: _vm.updateDate },
                                      model: {
                                        value: _vm.editPpto.status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.editPpto, "status", $$v)
                                        },
                                        expression: "editPpto.status"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Fecha cambio status" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.editPpto.update_date,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editPpto,
                                            "update_date",
                                            $$v
                                          )
                                        },
                                        expression: "editPpto.update_date"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Fecha entregado" }
                                  },
                                  [
                                    _c(
                                      "b-input-group",
                                      [
                                        _c("datetime", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                _vm.editPpto.status ===
                                                "Enviado"
                                                  ? "required"
                                                  : "",
                                              expression:
                                                "(editPpto.status === 'Enviado') ? 'required':''"
                                            }
                                          ],
                                          attrs: {
                                            "data-vv-scope": "gestion",
                                            name: "Fecha entregado",
                                            "input-class": "form-control",
                                            phrases: {
                                              ok: "Ok",
                                              cancel: "Cancelar"
                                            },
                                            type: "datetime",
                                            auto: true,
                                            "minute-step": 15,
                                            "value-zone": "local",
                                            zone: "local"
                                          },
                                          model: {
                                            value: _vm.editPpto.fecha_entregado,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editPpto,
                                                "fecha_entregado",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editPpto.fecha_entregado"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-input-group-text",
                                          {
                                            attrs: { slot: "append" },
                                            on: {
                                              click: function($event) {
                                                _vm.editPpto.fecha_entregado =
                                                  ""
                                              }
                                            },
                                            slot: "append"
                                          },
                                          [
                                            _c(
                                              "strong",
                                              { staticClass: "text-danger" },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-times"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "error" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first(
                                            "gestion.Fecha entregado"
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Observaciones" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.editPpto.observaciones,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editPpto,
                                            "observaciones",
                                            $$v
                                          )
                                        },
                                        expression: "editPpto.observaciones"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticStyle: { "min-height": "10rem" } },
                      [
                        _vm.hasPermision("E")
                          ? _c(
                              "b-col",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.editPptoFlag = false
                                      }
                                    }
                                  },
                                  [_vm._v("Cancelar")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  { on: { click: _vm.saveEditPpto } },
                                  [_vm._v("Guardar")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm.showPptoTable
                ? [
                    _vm.presupuestos.length > 0
                      ? _c("b-table", {
                          attrs: {
                            striped: "",
                            hover: "",
                            items: _vm.presupuestos,
                            fields: _vm.table_fields
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "entidad",
                              fn: function(row) {
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        row.item.id_entidad.nombre_entidad
                                      ) +
                                      "\n        "
                                  )
                                ]
                              }
                            },
                            {
                              key: "actions",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-dropdown",
                                    {
                                      attrs: { variant: "link", "no-caret": "" }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "button-content" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-ellipsis-v",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasPermision("E")
                                        ? _c(
                                            "b-dropdown-item-button",
                                            {
                                              on: {
                                                click: function($event) {
                                                  _vm.deletePresupuesto(
                                                    row.item
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Eliminar")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasPermision("E")
                                        ? _c(
                                            "b-dropdown-item-button",
                                            {
                                              on: {
                                                click: function($event) {
                                                  _vm.editPresupuesto(row.item)
                                                }
                                              }
                                            },
                                            [_vm._v("Editar")]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _vm.hasPermision("E")
                          ? _c(
                              "b-col",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.showPptoTable = false
                                      }
                                    }
                                  },
                                  [_vm._v("Atras")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  { on: { click: _vm.addNewPpto } },
                                  [_vm._v("Añadir presupuesto")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ]
          : [
              _vm.loading > 0
                ? [_c("Loader", { attrs: { delay: 0 } })]
                : _c(
                    "div",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: {
                                        label: "Clase establecimiento GN"
                                      }
                                    },
                                    [
                                      _vm.type === "caldera"
                                        ? _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "",
                                                expression: "''"
                                              }
                                            ],
                                            staticClass: "mb-3",
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Clase establecimiento GN",
                                              options:
                                                _vm.clase_establecimiento_comercial_options,
                                              "text-field": "tipo",
                                              "value-field": "id",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.detalles[
                                                  "id_clase_establecimiento_gn_" +
                                                    _vm.type
                                                ].id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles[
                                                    "id_clase_establecimiento_gn_" +
                                                      _vm.type
                                                  ],
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles['id_clase_establecimiento_gn_'+type].id"
                                            }
                                          })
                                        : _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "mb-3",
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Clase establecimiento GN",
                                              options:
                                                _vm.clase_establecimiento_comercial_options,
                                              "text-field": "tipo",
                                              "value-field": "id",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles[
                                                  "id_clase_establecimiento_gn_" +
                                                    _vm.type
                                                ].id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles[
                                                    "id_clase_establecimiento_gn_" +
                                                      _vm.type
                                                  ],
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles['id_clase_establecimiento_gn_'+type].id"
                                            }
                                          }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              "gestion.Clase establecimiento GN"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _vm.type === "comercial"
                                    ? _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Gas en finca" }
                                        },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.isRequired2,
                                                expression: "isRequired2"
                                              }
                                            ],
                                            staticClass: "mb-3",
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Gas en finca",
                                              options: _vm.gas_options,
                                              "text-field": "gas",
                                              "value-field": "id",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.id_gas_finca.id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles.id_gas_finca,
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.id_gas_finca.id"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Gas en finca"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.type === "caldera"
                                    ? _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Gas en finca" }
                                        },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "mb-3",
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Gas en finca",
                                              options: _vm.gas_options,
                                              "text-field": "gas",
                                              "value-field": "id",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.id_gas_en_finca.id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles.id_gas_en_finca,
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.id_gas_en_finca.id"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Gas en finca"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Status gestión" }
                                    },
                                    [
                                      _c("b-form-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass: "mb-3",
                                        attrs: {
                                          "data-vv-scope": "gestion",
                                          name: "Status gestión",
                                          options: _vm.status_options,
                                          "text-field": "status",
                                          "value-field": "id",
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        on: { input: _vm.setFechaCambioStatus },
                                        model: {
                                          value:
                                            _vm.detalles[
                                              "id_status_gestion_" + _vm.type
                                            ].id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles[
                                                "id_status_gestion_" + _vm.type
                                              ],
                                              "id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "detalles['id_status_gestion_'+type].id"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              "gestion.Status gestión"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Fecha cambio status" }
                                    },
                                    [
                                      _c("datetime", {
                                        attrs: {
                                          "input-class": "form-control",
                                          phrases: {
                                            ok: "Ok",
                                            cancel: "Cancelar"
                                          },
                                          type: "date",
                                          auto: true,
                                          "value-zone": "local",
                                          zone: "local",
                                          disabled: ""
                                        },
                                        model: {
                                          value:
                                            _vm.detalles.fecha_cambio_status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "fecha_cambio_status",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "detalles.fecha_cambio_status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Es cliente" }
                                    },
                                    [
                                      _c("b-form-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.isRequired,
                                            expression: "isRequired"
                                          }
                                        ],
                                        staticClass: "mb-3",
                                        attrs: {
                                          "data-vv-scope": "gestion",
                                          name: "Es cliente",
                                          options: _vm.cliente_options,
                                          "text-field": "text",
                                          "value-field": "value",
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value: _vm.detalles.cliente,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "cliente",
                                              $$v
                                            )
                                          },
                                          expression: "detalles.cliente"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              "gestion.Es cliente"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Motivo no potencial" }
                                    },
                                    [
                                      _c("b-form-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.noPotencialValidate,
                                            expression: "noPotencialValidate"
                                          }
                                        ],
                                        staticClass: "mb-3",
                                        attrs: {
                                          "data-vv-scope": "gestion",
                                          name: "Motivo no potencial",
                                          options:
                                            _vm.motivo_no_potencial_options,
                                          "text-field": "motivo",
                                          "value-field": "motivo",
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value:
                                            _vm.detalles.motivo_no_potencial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "motivo_no_potencial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "detalles.motivo_no_potencial"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              "gestion.Motivo no potencial"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Motivo rechazo" }
                                    },
                                    [
                                      _c("b-form-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.rechazadoValidate,
                                            expression: "rechazadoValidate"
                                          }
                                        ],
                                        staticClass: "mb-3",
                                        attrs: {
                                          "data-vv-scope": "gestion",
                                          name: "Motivo rechazo",
                                          options: _vm.motivo_rechazo_options,
                                          "text-field": "motivo",
                                          "value-field": "motivo",
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value: _vm.detalles.motivo_rechazo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "motivo_rechazo",
                                              $$v
                                            )
                                          },
                                          expression: "detalles.motivo_rechazo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              "gestion.Motivo rechazo"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                {
                                  staticStyle: { "margin-top": "2rem" },
                                  on: {
                                    click: function($event) {
                                      _vm.showPptoTable = true
                                    }
                                  }
                                },
                                [
                                  _vm._v("Presupuestos\n            "),
                                  _c(
                                    "b-badge",
                                    { attrs: { variant: "info" } },
                                    [_vm._v(_vm._s(_vm.presupuestos.length))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.presupuestos.length > 0
                                ? _c(
                                    "b-button",
                                    {
                                      staticStyle: { "margin-top": "2rem" },
                                      attrs: { variant: "info" },
                                      on: { click: _vm.sendEmail }
                                    },
                                    [
                                      _vm._v("\n            Enviar correo "),
                                      _c("i", { staticClass: "fa fa-envelope" })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("p", { staticClass: "col-form-label" }, [
                                _vm._v(_vm._s(_vm.aparatos_string))
                              ]),
                              _vm._v(" "),
                              _vm.aparatos.length === 0
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: { color: "cornflowerblue" }
                                    },
                                    [
                                      _c("i", [
                                        _vm._v("Ningún aparato añadido")
                                      ])
                                    ]
                                  )
                                : _c("b-table", {
                                    staticStyle: { "max-height": "25rem" },
                                    attrs: {
                                      responsive: "",
                                      striped: "",
                                      hover: "",
                                      items: _vm.aparatos,
                                      fields: [
                                        {
                                          key: "aparato_or_vehiculo",
                                          label: "Aparato"
                                        },
                                        {
                                          key: "potencia_or_consumo",
                                          label: "Potencia"
                                        },
                                        { key: "actions", label: "" }
                                      ]
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "actions",
                                        fn: function(row) {
                                          return _vm.hasPermision("E")
                                            ? [
                                                _c(
                                                  "b-button",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.editAparato(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Editar")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.deleteAparato(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Borrar")]
                                                )
                                              ]
                                            : undefined
                                        }
                                      }
                                    ])
                                  }),
                              _vm._v(" "),
                              _vm.hasPermision("E")
                                ? _c(
                                    "b-button",
                                    { on: { click: _vm.addVehiculo } },
                                    [_vm._v("Añadir")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("p", { staticClass: "col-form-label" }, [
                                _vm._v("Combustibles, usos y consumo anual")
                              ]),
                              _vm._v(" "),
                              _vm.combustibles.length === 0
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: { color: "cornflowerblue" }
                                    },
                                    [
                                      _c("i", [
                                        _vm._v("Ningún combustible añadido")
                                      ])
                                    ]
                                  )
                                : _c("b-table", {
                                    staticStyle: { "max-height": "25rem" },
                                    attrs: {
                                      responsive: "",
                                      striped: "",
                                      hover: "",
                                      items: _vm.combustibles,
                                      fields: [
                                        {
                                          key: "combustible",
                                          label: "Combustible"
                                        },
                                        { key: "uso", label: "Uso" },
                                        {
                                          key: "consumo_anual",
                                          label: "Consumo anual"
                                        },
                                        { key: "actions", label: "" }
                                      ]
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "actions",
                                        fn: function(row) {
                                          return _vm.hasPermision("E") &&
                                            _vm.type === "comercial"
                                            ? [
                                                _c(
                                                  "b-button",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.editCombustible(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Editar")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.deleteCombustible(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Borrar")]
                                                )
                                              ]
                                            : undefined
                                        }
                                      }
                                    ])
                                  }),
                              _vm._v(" "),
                              _vm.hasPermision("E") && _vm.type === "comercial"
                                ? _c(
                                    "b-button",
                                    { on: { click: _vm.addCombustible } },
                                    [_vm._v("Añadir")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.type === "comercial"
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Nombre propietario" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.sendingEmail
                                                  ? "required"
                                                  : "",
                                                expression:
                                                  "(sendingEmail) ? 'required':''"
                                              }
                                            ],
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Nombre propietario",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.nombre_propietario,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "nombre_propietario",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.nombre_propietario"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Nombre propietario"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: {
                                            label: "Teléfono propietario"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.sendingEmail
                                                  ? "required"
                                                  : "",
                                                expression:
                                                  "(sendingEmail) ? 'required':''"
                                              }
                                            ],
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Teléfono propietario",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles
                                                  .telefono_propietario,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "telefono_propietario",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.telefono_propietario"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Teléfono propietario"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Email propietario" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.sendingEmail
                                                  ? "required"
                                                  : "",
                                                expression:
                                                  "(sendingEmail) ? 'required':''"
                                              }
                                            ],
                                            attrs: {
                                              name: "Email propietario",
                                              "data-vv-scope": "gestion",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.email_propietario,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "email_propietario",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.email_propietario"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Email propietario"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type === "caldera"
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Nombre presidente" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.sendingEmail
                                                  ? "required"
                                                  : "",
                                                expression:
                                                  "(sendingEmail) ? 'required':''"
                                              }
                                            ],
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Nombre presidente",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.nombre_presidente,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "nombre_presidente",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.nombre_presidente"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Nombre presidente"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: {
                                            label: "Teléfono presidente"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.sendingEmail
                                                  ? "required"
                                                  : "",
                                                expression:
                                                  "(sendingEmail) ? 'required':''"
                                              }
                                            ],
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Teléfono presidente",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles
                                                  .telefono_presidente,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "telefono_presidente",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.telefono_presidente"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Teléfono presidente"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Email presidente" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.sendingEmail
                                                  ? "required"
                                                  : "",
                                                expression:
                                                  "(sendingEmail) ? 'required':''"
                                              }
                                            ],
                                            attrs: {
                                              "data-vv-scope": "gestion",
                                              name: "Email presidente",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.email_presidente,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "email_presidente",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.email_presidente"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "gestion.Email presidente"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type === "caldera"
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: {
                                            label: "Nombre administrador finca"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles
                                                  .nombre_administrador_finca,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "nombre_administrador_finca",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.nombre_administrador_finca"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: {
                                            label:
                                              "Teléfono administrador finca"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles
                                                  .telefono_administrador_finca,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "telefono_administrador_finca",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.telefono_administrador_finca"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: {
                                            label: "Email administrador finca"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles
                                                  .email_administrador_finca,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles,
                                                  "email_administrador_finca",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.email_administrador_finca"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Observaciones" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value: _vm.detalles.observaciones,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "observaciones",
                                              $$v
                                            )
                                          },
                                          expression: "detalles.observaciones"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Datos de contacto" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value: _vm.detalles.datos_contacto,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "datos_contacto",
                                              $$v
                                            )
                                          },
                                          expression: "detalles.datos_contacto"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Empresa instaladora" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value:
                                            _vm.detalles.empresa_instaladora,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "empresa_instaladora",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "detalles.empresa_instaladora"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _vm.hasPermision("E")
                            ? _c(
                                "b-col",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c(
                                    "b-button",
                                    { on: { click: _vm.cancel } },
                                    [_vm._v("Cancelar")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.save($event)
                                        }
                                      }
                                    },
                                    [_vm._v("Guardar")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("br")
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details/comercial_gestion.vue?vue&type=template&id=0fd7e6e1&
// module id = null
// module chunks = 